import { render, staticRenderFns } from "./toileting-section.vue?vue&type=template&id=c1c1bf3c"
import script from "./toileting-section.vue?vue&type=script&lang=js"
export * from "./toileting-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports